export function IsValidEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).trim().toLowerCase());
}

export function IsValidPassword(password) {
    var re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
    return re.test(String(password).trim());
}

export function OrderValidationMessage(order) {
    if ( order.customerFirstName.trim() === "") {
        return"Proszę wpisać swoje imię";
    }
    if (order.customerLastName.trim() === "") {
        return "Proszę wpisać swoje nazwisko";
    }
    if (order.customerEmail.trim() === "") {
        return "Proszę wpisać swój adres email";
    } else if (!IsValidEmail(order.customerEmail.trim())) {
        return "Proszę wpisać poprawny adres email";
    }
    if (!order.acceptedTerms) {
        return "Proszę zaakceptować regulamin i politykę prywatności";
    }
    if (order.needInvoice) {
        if (order.companyName.trim() === "") {
            return "Proszę wpisać nazwę firmy";
        }
        if (order.companyNip.trim() === "") {
            return "Proszę wpisać NIP firmy";
        }

        if (order.city.trim() === "") {
            return "Proszę wpisać miasto";
        }
        if (order.postcode.trim() === "") {
            return "Proszę wpisać kod pocztowy";
        }
        if (order.address.trim() === "") {
            return "Proszę wpisać adres";
        }
    }

    return "";
}
